import axios from 'axios';
import headers from "../Header";

let baseUrl = "/sdpi/dashboard-penduduk-baru"

class DashboardPendudukBaruService {
    getData(param) {
        let url=""
        if (param) {
            url = baseUrl + "" + param
        } else {
            url = baseUrl
        }
        return axios.get(url, {
            headers: headers(),
        });
    }

}

export default new DashboardPendudukBaruService();